<template>
  <div class="main-wrapper">
    <transition name="fade-opacity-lazy">
      <modal-form v-if="isActiveModal"/>
    </transition>
    <main-header/>
    <div :class="['sub-wrapper', 'lenis']"
         ref="scrollContainer">
      <router-view/>
    </div>
    <main-footer/>
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";
import MainHeader from "@/components/widgets/MainHeader.vue";
import MainFooter from "@/components/widgets/MainFooter.vue";
import scrollMixin from "@/mixins/scroll.mixin";
import ModalForm from "@/components/entities/modals/ModalForm.vue";

export default {
  name: "MainLayout",
  components: {ModalForm, MainFooter, MainHeader},
  mixins: [scrollMixin],
  data() {
    return {
      activeWhiteBlock: false,
      ticking: false
    }
  },
  beforeUnmount() {
    if (this.lenis) this.lenis.destroy()
  },
  computed: {
    ...mapState(['isActiveModal'])
  },
  mounted() {
    this.totalSlides = 8;
    this.initLenis();
    this.checkSize();
    this.checkHeaderFixedStatic();
    addEventListener('resize', this.checkSize)
  },
  unmounted() {
    removeEventListener('resize', this.checkSize)
  },
  methods: {
    ...mapActions('scrollModule', ['OPTIONS_HORIZONTAL_SCROLL']),
    ...mapActions(['IS_MOBILE', 'ACTIVE_FIXED_HEADER', 'ACTIVE_WHITE_BLOCK', 'IS_HISTORY_SCREEN']),
    checkSize() {
      this.innerHeight = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${this.innerHeight * 0.01}px`);
      this.innerWidth = window.innerWidth;
      document.documentElement.style.setProperty('--vw', `${this.innerWidth * 0.01}px`);
      this.IS_MOBILE(this.innerWidth < 769)
    },
    checkHeaderFixed() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.checkHeaderFixedStatic();
          this.checkActiveClass();
          this.ticking = false;
        });
        this.ticking = true;
      }
    },
    checkHeaderFixedStatic() {
      let startScreen = document.querySelector('.start-screen-container')
      if (startScreen) {
        let info = startScreen.getBoundingClientRect();
        let infoHeight = info.height;
        let infoY = info.top;
        let isFixedHeader = infoHeight <= Math.abs(infoY);
        this.ACTIVE_FIXED_HEADER(isFixedHeader);
      }
      let whiteScreens = document.querySelector('.screens-white-wrapper')
      if (whiteScreens) {
        let info = whiteScreens.getBoundingClientRect();
        let isWhite = info.bottom > 50 && info.top < 50;
        this.ACTIVE_WHITE_BLOCK(isWhite)
      }
      let historyScreen = document.querySelector('.history-screen-container')
      if (historyScreen) {
        let info = historyScreen.getBoundingClientRect();
        let isHistoryScreen = info.bottom > 50 && info.top < 50;
        this.IS_HISTORY_SCREEN(isHistoryScreen)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.sub-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

</style>